module["exports"] = [
  "ТОВ",
  "ПАТ",
  "ПрАТ",
  "ТДВ",
  "КТ",
  "ПТ",
  "ДП",
  "ФОП"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/company/prefix.js
// module id = 2803
// module chunks = 2